import React from 'react';
export function BalloonIcon({
  className
}: {
  className?: string;
}) {
  return <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round" className={className} aria-hidden="true" data-id="element-229" data-mp="3sa7ikiyxqysw">
      <path d="M12 2.5c-3.6 0-6.5 2.9-6.5 6.6 0 4 3.3 7.4 6.5 7.9 3.2-.5 6.5-3.9 6.5-7.9 0-3.7-2.9-6.6-6.5-6.6Z" data-id="element-230" data-mp="3ja17f3qpmaww" />
      <path d="m10.8 17 1.2 1.6 1.2-1.6" data-id="element-231" data-mp="3eayfmkzqq16v" />
      <path d="M12 18.6c0 1.2-1.4 1.6-1.4 2.7" data-id="element-232" data-mp="3ebzt0w48azrr" />
      <path d="M9.2 6.4a3.4 3.4 0 0 1 2.3-1.4" data-id="element-233" data-mp="39if0vkpbh00h" />
    </svg>;
}